var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccomplice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.981 511.981",
    style: {
      enableBackground: "new 0 0 511.981 511.981"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#434A54"
    },
    d: "M460.202,397l-1.812-0.516c-26.469-7.125-35.421-13.937-47.202-18.437 c-41.795-15.921-52.669-27.39-55.45-32.811c-0.109-0.188-0.188-0.406-0.281-0.609l-0.343-48.546l-99.123-1.124l-99.121,1.125 l-0.344,48.546c-0.094,0.203-0.172,0.422-0.281,0.609c-2.781,5.421-13.655,16.89-55.451,32.811 c-11.78,4.5-20.733,11.312-47.201,18.437l-1.812,0.516c-24.093,7.952-40.311,30.312-40.311,55.529v59.451h244.521h244.521V452.53 C500.512,427.311,484.294,404.952,460.202,397z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CCD1D9"
    },
    points: "324.096,377.173 261.881,340.503 175.213,389.89 208.321,511.98 297.661,511.98  334.316,415.389 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#DA4453"
    },
    points: "278.943,405.296 234.664,405.296 210.993,493.919 216.773,511.98 297.661,511.98  300.27,476.294 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED5564"
    },
    d: "M284.756,348.689c-2.078-2.015-4.875-3.093-7.75-3.015l-42.67,1.281 c-5.766,0.188-10.344,4.905-10.344,10.655v47.685c0,5.906,4.781,10.672,10.672,10.672h42.654c5.891,0,10.672-4.766,10.672-10.672 V356.33C287.99,353.455,286.818,350.705,284.756,348.689z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9ED"
    },
    d: "M184.775,400.203l72.028-37.123l73.841,38.091l14.125-20.889l19.312-25.999 c-4.938-3.891-7.266-6.921-8.344-9.046c-0.109-0.188-0.188-0.406-0.281-0.609l-0.343-48.546l-99.122-1.125l-99.121,1.125 l-0.344,48.546c-0.094,0.203-0.172,0.422-0.281,0.609c-1.094,2.156-3.5,5.28-8.609,9.249L184.775,400.203z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#656D78"
    },
    points: "234.664,511.98 156.776,308.113 128.808,378.391 161.354,403.389 155.542,427.389  193.572,511.98  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#656D78"
    },
    points: "278.896,511.98 355.207,308.113 384.751,378.391 352.207,403.389 358.018,427.389  319.988,511.98  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EAC6BB"
    },
    d: "M393.531,202.133c0,89.372-85.184,171.634-137.541,171.634c-52.342,0-137.542-82.262-137.542-171.634 S180.024,53.795,255.99,53.795S393.531,112.761,393.531,202.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F4545"
    },
    d: "M427.905,138.948c-9.952-5.062-23.904-9.531-41.451-13.312 c-34.966-7.516-81.293-11.672-130.463-11.672s-95.496,4.156-130.464,11.671c-17.546,3.781-31.499,8.25-41.451,13.312 c-13.327,6.781-20.077,15.093-20.077,24.687c0,9.609,6.75,17.921,20.077,24.702c9.952,5.062,23.905,9.531,41.451,13.312 c34.968,7.516,81.294,11.672,130.464,11.672s95.497-4.156,130.463-11.671c17.547-3.781,31.499-8.25,41.451-13.312 c13.328-6.781,20.078-15.093,20.078-24.702C447.983,154.041,441.233,145.729,427.905,138.948z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#965353"
    },
    d: "M362.518,28.655C350.269,9.906,332.441,0,310.988,0c-13.249,0-27.593,3.672-42.655,10.922 c-4.625,2.234-8.922,4.64-12.343,6.734C245.616,11.328,223.851,0,200.993,0c-21.452,0-39.279,9.906-51.529,28.655 c-14.249,21.78-21.468,56.326-21.468,102.668c0,9.109,8.594,14.531,15.062,17.796c6.812,3.453,16.218,6.812,27.233,9.75 c14.687,3.89,45.357,10.453,85.699,10.453c40.343,0,71.013-6.562,85.7-10.453c11.016-2.938,20.421-6.296,27.232-9.75 c6.468-3.266,15.062-8.688,15.062-17.796C383.984,84.981,376.766,50.435,362.518,28.655z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccomplice);
export default __webpack_public_path__ + "static/media/accomplice.091fe6a7177b1f1ea8e80744873d790e.svg";
export { ForwardRef as ReactComponent };